import React, { useState } from 'react';
import { Table, Button, Form } from 'react-bootstrap';
import Navbar from '../../Components/Navbar';
import '../Secretary/Table.css';
import { API_BASE_URL } from '../../config';

export default function ApplicationDates() {
  const [rows, setRows] = useState([
    { Open_Date: '', Time_1: '', Close_Date: '', Time_2: '', Year: '' },
  ]);

  const handleChange = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;
    setRows(updatedRows);
  };

  const handleSubmit = async (index) => {
    const { Open_Date, Time_1, Close_Date, Time_2, Year } = rows[index];

    if (!Open_Date || !Time_1 || !Close_Date || !Time_2 || !Year) {
      alert('Please fill in all fields before submitting.');
      return;
    }

    const formData = new FormData();
    formData.append('Open_Date', Open_Date);
    formData.append('Time_1', Time_1);
    formData.append('Close_Date', Close_Date);
    formData.append('Time_2', Time_2);
    formData.append('Year', Year);

    try {
      const response = await fetch(`${API_BASE_URL}/ApplicationDates.php`, {
        method: 'POST',
        body: formData,
      });

      const result = await response.json();
      alert(result.message);

      if (result.status === "success") {
        const updatedRows = [...rows];
        updatedRows[index] = { Open_Date: '', Time_1: '', Close_Date: '', Time_2: '', Year: '' };
        setRows(updatedRows);
      }
    } catch (error) {
      console.error('Upload failed', error);
      alert('Upload failed.');
    }
  };

  return (
    <div>
      <Navbar />
      <h1 className="page-title">Application Open & Close Dates</h1>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Application Open Date</th>
            <th>Time</th>
            <th>Application Close Date</th>
            <th>Time</th>
            <th>Year</th>
            <th>Submit</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => (
            <tr key={index}>
              <td>
                <Form.Control
                  type="date"
                  value={row.Open_Date}
                  onChange={(e) => handleChange(index, 'Open_Date', e.target.value)}
                />
              </td>
              <td>
                <Form.Control
                  type="time"
                  value={row.Time_1}
                  onChange={(e) => handleChange(index, 'Time_1', e.target.value)}
                />
              </td>
              <td>
                <Form.Control
                  type="date"
                  value={row.Close_Date}
                  onChange={(e) => handleChange(index, 'Close_Date', e.target.value)}
                />
              </td>
              <td>
                <Form.Control
                  type="time"
                  value={row.Time_2}
                  onChange={(e) => handleChange(index, 'Time_2', e.target.value)}
                />
              </td>
              <td>
                <Form.Control
                  type="text"
                  placeholder="Enter Year"
                  value={row.Year}
                  onChange={(e) => handleChange(index, 'Year', e.target.value)}
                />
              </td>
              <td>
                <Button className="view-button" onClick={() => handleSubmit(index)}>Submit</Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}
